import { render, staticRenderFns } from "./MultiSplitShiftItem.vue?vue&type=template&id=63bbdf74&"
import script from "./MultiSplitShiftItem.vue?vue&type=script&lang=js&"
export * from "./MultiSplitShiftItem.vue?vue&type=script&lang=js&"
import style0 from "./MultiSplitShiftItem.vue?vue&type=style&index=0&id=63bbdf74&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports